import { Component, Input } from '@angular/core';
import { Multiline } from './va-multiline';

@Component({
  styleUrls: ['./va-multiline.component.scss'],
  template: `
    <span *ngIf="!config.link; else titleWithUrl" class="title">{{ config.title }}</span>
    <ng-template #titleWithUrl>
      <a *ngIf="config?.link?.external" [routerLink]="config?.link?.url" [target]="config?.link?.target" class="title">
        <span>{{ config.title }}</span>
      </a>
      <a
        *ngIf="!config?.link?.external"
        [routerLink]="config?.link?.url"
        [queryParams]="config?.link?.queryParams"
        [target]="config?.link?.target"
        class="title"
      >
        <span>{{ config.title }}</span>
      </a>
    </ng-template>
    <span
      *ngIf="config?.subtitle"
      class="subtitle"
      [style.color]="config?.description ? 'rgba(0,0,0,0.87)' : 'rgba(0,0,0,0.54)'"
    >
      {{ config?.subtitle }}
    </span>
    <span *ngIf="config?.description" class="description">{{ config?.description }}</span>
  `,
})
export class VaMultilineComponent {
  @Input() config: Multiline;
}
